import React from "react"
import SEO from '@/components/SEO'
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Separator } from "@/components/ui/separator"
import { Button } from "@/components/ui/button"

const EDUCATIONAL = [
  { id: 1, name: "Gyanmudra Education Foundation", bank: "Shri Bhavnagar Nagrik Sahkari Bank", propertyType: "School Property", date: "05/05/2022", valuation: "₹10.70 Crore" },
  { id: 2, name: "Shree Sahjanand Education Trust", propertyType: "School Building", date: "06/12/2022", valuation: "₹2.30 Crore" },
  { id: 3, name: "Asst. Charity Commissioner", propertyType: "Government Office", date: "16/02/2023", valuation: "₹3.33 Crore" },
]

const RESIDENTIAL = [
  { id: 4, name: "Shri Chetanbhai Tamboli", bank: "Shri Bhavnagar Nagrik Sahkari Bank", propertyType: "Residential Bungalow", valuation: "₹9.94 Crore" },
  { id: 5, name: "Dilipsinh Ajitsinh Zala", bank: "SBI", propertyType: "Residential Bungalow", valuation: "₹3.39 Crore" },
  { id: 6, name: "Urmilaben Mahendrbhai Rana", bank: "SBI", propertyType: "Residential Bungalow", valuation: "₹3.21 Crore" },
  { id: 7, name: "Kamleshbhai Bodar", bank: "Saurashtra Gramin Bank", propertyType: "Residence", valuation: "₹5.26 Crore" },
  { id: 8, name: "Gopalbhai Mafatlal Dave", bank: "Bank of Baroda", propertyType: "Residence", valuation: "₹24.91 Crore" },
]

const COMMERCIAL = [
  { id: 9, name: "Nimeshbhai Desai", propertyType: "Residential cum Commercial", valuation: "₹4.94 Crore" },
  { id: 10, name: "The Coastal Leela Resort", bank: "Saurashtra Gramin Bank", propertyType: "Commercial Property (Resort)", valuation: "₹24.24 Crore" },
  { id: 11, name: "Aatman Hospitality", bank: "Bank of Baroda", propertyType: "Resort", valuation: "₹3.65 Crore" },
]

const INDUSTRIAL = [
  { id: 12, name: "Bharat Green Ship Recycle LLP", bank: "SBI", propertyType: "Factory", valuation: "₹2.41 Crore" },
  { id: 13, name: "Das Pendawala Pvt. Ltd.", bank: "Ministry of Food", propertyType: "Factory", valuation: "₹1.90 Crore" },
  { id: 14, name: "Priya Blue Industries Pvt. Ltd.", bank: "Bank of Baroda", propertyType: "Industrial Property", valuation: "₹57.31 Crore" },
]

const ProjectsGrid = ({ items }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {items.map((p) => (
      <Card key={p.id} className="rounded-xl shadow-md bg-white border">
        <CardHeader>
          <CardTitle className="font-semibold">{p.name}</CardTitle>
          <CardDescription>
            <span className="text-sm text-muted-foreground">{p.bank ?? ""}</span>
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between gap-4">
            <Badge variant="default">{p.propertyType}</Badge>
            <div className="text-right">
              <div className="text-blue-600 font-bold text-lg">{p.valuation}</div>
              {p.date && <div className="text-sm text-muted-foreground">{p.date}</div>}
            </div>
          </div>
        </CardContent>
      </Card>
    ))}
  </div>
)

export default function MajorAssignments() {
  return (
    <div className="bg-white pt-32 pb-16 px-6">
      <SEO
        title="Major Assignments — Mehta Associates"
        description="Selected major valuation assignments delivered by Mehta Associates across institutional, residential, commercial and industrial properties."
        pathname="/major-assignments"
        keywords={["major valuation assignments", "Mehta Associates", "property valuation projects"]}
      />
      <div className="max-w-7xl mx-auto">
        <header className="mb-8 text-center">
          <h1 className="text-3xl font-semibold">Major Assignments & Valuation Projects</h1>
          <p className="mt-2 text-muted-foreground">Over 8+ years of experience delivering multi-crore valuations across institutional, residential, commercial and industrial assets.</p>
        </header>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Educational & Institutional Projects</h2>
          <ProjectsGrid items={EDUCATIONAL} />
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Residential Properties</h2>
          <ProjectsGrid items={RESIDENTIAL} />
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Commercial & Mixed Use</h2>
          <ProjectsGrid items={COMMERCIAL} />
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Industrial & Factory Projects</h2>
          <ProjectsGrid items={INDUSTRIAL} />
        </section>

        <div className="mt-12 rounded-lg overflow-hidden">
          <div className="bg-primary text-white py-12 px-6 rounded-lg">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
              <div>
                <h3 className="text-2xl font-semibold">Need Professional Property Valuation?</h3>
                <p className="mt-1 text-white/90">Expert valuation services for lenders, investors and corporate clients.</p>
              </div>
              <div>
                <Button className="px-6" variant="default">Request Valuation</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
